<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Reports Builder") }}</div>

      <div class="mt-3 mb-2">
        <div class="row">
          <!-- Date From-->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReportsDetail.from_date"
                  v-on:click="clearDate(2)"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchReportsDetail.from_date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @input="onchangeDate()"
                ></Datepicker>
                <label :class="fetchReportsDetail.from_date ? 'active' : ''"
                  >{{ $t("Report") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- Date To -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReportsDetail.to_date"
                  v-on:click="clearDate('to_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchReportsDetail.to_date"
                  name="selectenddate_3"
                  id="selectenddate_3"
                  v-validate="'required'"
                  :typeable="true"
                  @input="onchangeDate()"
                ></Datepicker>
                <label :class="fetchReportsDetail.to_date ? 'active' : ''"
                  >{{ $t("Report") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <!--<div style="width: 100%"></div>-->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="onGetReportData"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div>
        </div>
      </div>

      <!--START GroupByArray Filter -->
      <div class="section-wrapper">
        <div
          class="sectionName border-bottom d-flex justify-content-between pointer"
          @click="collapseObj.groupByFilter = !collapseObj.groupByFilter"
        >
          <div class="fs-17 font-weight-bold">
            Group By Filter &nbsp;&nbsp;
            <span
              v-if="!collapseObj.groupByFilter"
              v-for="(group, groupIndex) in selectedGroupByArray"
              class="p-1 badge badge-primary badge-pill mr-2"
              :key="group.groupByKeyName + groupIndex + 'selectedlable'"
            >
              {{ group.tableHeaderName }}
            </span>
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.groupByFilter"
          >
          </span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.groupByFilter"
          >
          </span>
        </div>
        <b-collapse v-model="collapseObj.groupByFilter" class="">
          <div class="white-wrapper py-3 mb-2">
            <div class="row">
              <div
                class="col-1 d-flex flex-column justify-content-between align-items-center"
              >
                <div class="row mb-4">
                  <h6>
                    Available
                  </h6>
                </div>
                <div class="row">
                  <h6 @click="toggleShowDropDownFilter">
                    Selected&nbsp;
                  </h6>

                  <!-- <i
                    :style="{ 'font-size': '19px', color: showDropDownFilter ? '&#45;&#45;primary' : '&#45;&#45;gray' }"
                    :class="['pointer fa fa-filter align-content-center justify-content-center', showDropDownFilter ? 'text-blue' : '']"
                    @click="toggleShowDropDownFilter"
                  ></i>-->
                </div>
              </div>

              <div class="col-11">
                <div class="row mb-4">
                  <div class="text-blue font-weight-bold w-100">
                    <draggable
                      :list="groupByFilterArray"
                      :group="{
                        name: 'filterArrayGroup',
                        pull: true,
                        put: true,
                      }"
                      @change="onGroupFilterChange"
                      :move="checkMoveonGroupFilterChange"
                    >
                      <span
                        v-for="(group, groupIndex) in groupByFilterArray"
                        class="p-2 badge badge-secondary ml-3 mb-1 move"
                        :key="group.groupByKeyName + groupIndex + 'group'"
                      >
                        {{ group.tableHeaderName }}
                      </span>
                      <span>&nbsp;</span>
                    </draggable>
                  </div>
                </div>

                <div
                  class="row"
                  :style="{
                    'padding-left': showDropDownFilter ? '15px' : undefined,
                  }"
                >
                  <div class="text-blue font-weight-bold w-100">
                    <draggable
                      :class="[showDropDownFilter ? 'row w-100' : '']"
                      :list="selectedGroupByArray"
                      group="filterArrayGroup"
                      @change="onGroupFilterChange"
                      :move="checkMoveonGroupFilterChange"
                    >
                      <span
                        v-if="!showDropDownFilter"
                        v-for="(group, groupIndex) in selectedGroupByArray"
                        class="p-2 badge badge-primary ml-3 mb-1 move"
                        :key="group.groupByKeyName + groupIndex + 'selected'"
                      >
                        {{ group.tableHeaderName }}
                      </span>

                      <div
                        v-if="showDropDownFilter"
                        v-for="(group, groupIndex) in selectedGroupByArray"
                        style="z-index: 3;zoom: 0.74"
                        class="row flex-nowrap p-0 m-1 align-content-center justify-content-center"
                      >
                        <span>&nbsp;</span>
                        <span
                          style="z-index: 3"
                          class="p-2 badge badge-primary ml-3 py-3 move"
                        >
                          {{ group.tableHeaderName }}
                        </span>
                        <multiselect
                          style="z-index: 2;margin-left: -6px;"
                          v-model="group.selectedDropdownFilter"
                          @select="onSelectDropdownFilter($event, group, 'add')"
                          @remove="
                            onSelectDropdownFilter($event, group, 'remove')
                          "
                          placeholder="Select Filter"
                          :options="group.data"
                          :label="group.showLabelName"
                          :track-by="group.groupByKeyName"
                          :multiple="isMultiselectFilter"
                          :showLabels="false"
                          :allowEmpty="true"
                        ></multiselect>

                        <span>&nbsp;</span>
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <!--END GroupByArray Filter -->

      <!--START Payment Filter -->
      <div class="section-wrapper">
        <div
          class="sectionName border-bottom d-flex justify-content-between pointer"
          @click="collapseObj.paymentFilter = !collapseObj.paymentFilter"
        >
          <div class="fs-17 font-weight-bold">
            Payment Filter &nbsp;&nbsp;
            <span
              v-if="!collapseObj.paymentFilter"
              v-for="(payment, groupIndex) in selectedPaymentFilter"
              class="p-1 badge badge-primary badge-pill mr-2"
              :key="payment.key_name + groupIndex + 'selectedlablepayment'"
            >
              {{ payment.header_name }}
            </span>
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.paymentFilter"
          >
          </span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.paymentFilter"
          >
          </span>
        </div>
        <b-collapse v-model="collapseObj.paymentFilter" class="">
          <div class="white-wrapper py-3 mb-2">
            <div class="row">
              <div
                class="col-1 d-flex flex-column justify-content-between align-items-center"
              >
                <div class="row mb-4">
                  <h6>
                    Available
                  </h6>
                </div>
                <div class="row">
                  <h6>
                    Selected
                  </h6>
                </div>
              </div>

              <div class="col-11">
                <div class="row mb-4">
                  <div class="text-blue font-weight-bold w-100">
                    <draggable
                      tag="section"
                      :list="paymentFilter"
                      :group="{
                        name: 'paymentFilterGroup',
                        pull: true,
                        put: true,
                      }"
                      @change="onPaymentFilterChange"
                      :move="checkMoveonPaymentFilterChange"
                    >
                      <span
                        v-for="(payment, groupIndex) in paymentFilter"
                        class="p-2 badge badge-secondary ml-3 mb-1 move"
                        :key="payment.key_name + groupIndex + 'paymentFilter'"
                      >
                        {{ payment.header_name }}
                      </span>
                      <span>&nbsp;</span>
                    </draggable>
                  </div>
                </div>

                <div class="row">
                  <div class="text-blue font-weight-bold w-100">
                    <draggable
                      tag="section"
                      :list="selectedPaymentFilter"
                      group="paymentFilterGroup"
                      @change="onPaymentFilterChange"
                      :move="checkMoveonPaymentFilterChange"
                    >
                      <span
                        v-for="(payment, groupIndex) in selectedPaymentFilter"
                        class="p-2 badge badge-primary ml-3 mb-1 move"
                        :key="payment.key_name + groupIndex + 'selected'"
                      >
                        {{ payment.header_name }}
                      </span>
                      <span>&nbsp;</span>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <!--END Payment Filter -->

      <!--START Preset/Template -->
      <div class="section-wrapper mb-4">
        <div
          class="sectionName border-bottom d-flex justify-content-between pointer"
          @click="collapseObj.others = !collapseObj.others"
        >
          <div class="fs-17 font-weight-bold">
            Template Selection/Export &nbsp;&nbsp;
            <span
              v-if="!collapseObj.others && !!selectedPreset"
              class="p-1 badge badge-primary badge-pill mr-2"
            >
              {{ selectedPreset.rp_name }}
            </span>
          </div>
          <span
            class="icon-collapse-up blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="collapseObj.others"
          >
          </span>
          <span
            class="icon-collapse blue-icon mx-1 btn float-right"
            style="height: 30px"
            v-if="!collapseObj.others"
          >
          </span>
        </div>
        <b-collapse v-model="collapseObj.others" class="">
          <div class="white-wrapper py-3 mb-2">
            <div class="row">
              <div class="mb-3 col-lg-3 col-md-3">
                <div class="row flex-nowrap">
                  <multiselect
                    v-model="selectedPreset"
                    @select="onSelectPreset($event)"
                    @remove="onSelectPreset(null)"
                    placeholder="Please Select Template"
                    :options="savedPreset"
                    label="rp_name"
                    track-by="rp_id"
                    :multiple="false"
                    name="rp_name"
                    id="rp_name"
                    :showLabels="false"
                  ></multiselect>

                  <div
                    v-if="!!selectedPreset"
                    class="icon-delete-red blue-icon mx-1 btn align-self-center float-right"
                    @click="onDeletePreset"
                    :title="'Delete Preset'"
                    style="width: 29px; height: 30px;"
                  ></div>
                </div>
              </div>

              <div class="mb-3 col-lg-3 col-md-3" v-if="!selectedPreset">
                <div class="row flex-nowrap px-2">
                  <div class="input-material" :title="'Template Name'">
                    <input
                      v-model="presetName"
                      placeholder="Save current selection"
                      :disabled="!!selectedPreset"
                      type="text"
                      name="presetName"
                      id="presetName"
                    />
                    <label>Save current selection</label>
                  </div>

                  <div
                    class="icon-save-btn blue-icon mx-1 btn align-self-center float-right"
                    @click="onSavePreset"
                    :title="'Save Preset'"
                    style="width: 29px; height: 30px;"
                  ></div>
                </div>
              </div>

              <div class="mb-3 ml-auto">
                <button
                  class="btn-blue mb-2 align-self-center"
                  @click="generateReport()"
                >
                  <img
                    src="@/assets/img/icons/pdf-icon.svg"
                    height="25"
                    width="25"
                  />
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <!--END Preset/Template -->

      <!-- Filter Button -->
      <div class="">
        <div class="">
          <button
            class="btn-blue m-0 align-self-center filterButtonToggle"
            v-b-toggle.filterCollapse
            @click="collapseObj.filterToggle = !collapseObj.filterToggle"
          >
            <i
              :style="{ 'font-size': '19px', color: '&#45;&#45;gray' }"
              class="pointer fa fa-filter align-content-center justify-content-center mr-1"
            ></i>
            <i
              :style="{
                'font-size': '19px',
                color: '&#45;&#45;gray',
              }"
              :class="[
                collapseObj.filterToggle
                  ? 'fa fa-angle-double-left'
                  : 'fa fa-angle-double-right',
                'pointer fa fa-filter align-content-center justify-content-center',
              ]"
            ></i>
          </button>
          <div class="d-flex align-items-center" style="float:right">
            Download as:
            <a href="#" @click="ExportExcel()" title="Download as Excel">
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <div v-if="collapseObj.filterToggle" class="filterSection mr-1 p-1">
          <div class="px-1">
            <b-collapse
              id="filterCollapse"
              class="mt-2 collapse_direction"
              :style="{ 'min-height': '256px' }"
            >
              <div
                class="accordion"
                role="tablist"
                :style="{ 'max-width': `240px` }"
              >
                <section
                  class="search-filter-section mb-2"
                  v-for="(filter, index) in selectedGroupByArray"
                >
                  <div class="section-wrapper mb-4">
                    <div
                      class="sectionName border-bottom d-flex justify-content-between"
                    >
                      <div
                        class="fs-17 font-weight-bold pointer"
                        @click="
                          filter.filterAccordion = !!!filter.filterAccordion
                        "
                      >
                        {{ filter.tableHeaderName }}
                        {{
                          filter.selectedDropdownFilter.length
                            ? "(" + filter.selectedDropdownFilter.length + ")"
                            : ""
                        }}
                      </div>

                      <div class="d-flex">
                        <div
                          v-if="filter.selectedDropdownFilter.length > 0"
                          class="mr-1 pointer"
                          style="color: red;"
                          @click="clearSelectedFilter(filter, 'remove')"
                        >
                          <u>(clear)</u>
                        </div>

                        <span
                          class="icon-collapse-up blue-icon mx-1 btn float-right pointer"
                          style="height: 25px"
                          v-if="!!filter.filterAccordion"
                          @click="
                            filter.filterAccordion = !!!filter.filterAccordion
                          "
                        >
                        </span>
                        <span
                          class="icon-collapse blue-icon mx-1 btn float-right pointer"
                          style="height: 25px"
                          v-if="!filter.filterAccordion"
                          @click="
                            filter.filterAccordion = !!!filter.filterAccordion
                          "
                        >
                        </span>
                      </div>
                    </div>
                    <b-collapse v-model="filter.filterAccordion" class="">
                      <multiselect
                        v-model="filter.selectedDropdownFilter"
                        @select="onSelectDropdownFilter($event, filter, 'add')"
                        @remove="
                          onSelectDropdownFilter($event, filter, 'remove')
                        "
                        :placeholder="'Select ' + filter.tableHeaderName"
                        :options="filter.data"
                        :label="filter.showLabelName"
                        :track-by="filter.groupByKeyName"
                        :multiple="isMultiselectFilter"
                        :showLabels="false"
                        :allowEmpty="true"
                      >
                      </multiselect>
                    </b-collapse>
                  </div>

                  <div
                    class="search-filter-dropdown d-flex justify-content-between"
                    v-if="false"
                  >
                    <label class="search-label-title" style="font-weight: 900;">
                      {{ filter.tableHeaderName }}
                      {{
                        filter.selectedDropdownFilter.length
                          ? "(" + filter.selectedDropdownFilter.length + ")"
                          : ""
                      }}
                    </label>

                    <div class="d-block d-lg-none">
                      <img
                        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEzIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC45MTgzIDAuMjkyNUw2Ljc2MDExIDQuMTcyNUwyLjYwMTkzIDAuMjkyNUMyLjE4Mzk2IC0wLjA5NzUgMS41MDg3OSAtMC4wOTc1IDEuMDkwODMgMC4yOTI1QzAuNjcyODY4IDAuNjgyNSAwLjY3Mjg2OCAxLjMxMjUgMS4wOTA4MyAxLjcwMjVMNi4wMDk5MyA2LjI5MjVDNi40Mjc4OSA2LjY4MjUgNy4xMDMwNiA2LjY4MjUgNy41MjEwMiA2LjI5MjVMMTIuNDQwMSAxLjcwMjVDMTIuODU4MSAxLjMxMjUgMTIuODU4MSAwLjY4MjUgMTIuNDQwMSAwLjI5MjVDMTIuMDIyMiAtMC4wODc1IDExLjMzNjMgLTAuMDk3NSAxMC45MTgzIDAuMjkyNVoiIGZpbGw9IiM2OTY5NjkiLz4KPC9zdmc+Cg=="
                        alt=""
                      />
                    </div>

                    <div
                      v-if="filter.selectedDropdownFilter.length > 0"
                      class="ml-2"
                      style="color: red;"
                      @click="clearSelectedFilter(filter, 'remove')"
                    >
                      <u>(clear)</u>
                    </div>
                  </div>
                </section>
              </div>
            </b-collapse>
          </div>
        </div>

        <!--Excel Export Start-->
        <div class="swc-report d-none" ref="exportable_table">
          <div>
            <!--            <button class="btn-blue mb-2" @click="generateReport()">-->
            <!--              Download PDF-->
            <!--            </button>-->
            <table
              border="1"
              class="swc-report-table filmwise-report-table"
              id="finalTable"
            >
              <tr>
                <td
                  v-for="(filter, index) in selectedGroupByArray"
                  :key="'selectedGroupByArray' + 'index' + index"
                  class="table_header"
                >
                  {{ filter.tableHeaderName }}

                  <!-- <i
                    v-if="selectedGroupByArray.length > 1"
                    @click="
                      removeFromDragged(
                        filter.groupByKeyName,
                        'selectedGroupByArray'
                      )
                    "
                    class="ml-1 fa fa-close pointer align-content-center justify-content-center"
                  >
                  </i> -->
                </td>
                <td
                  v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                  :key="'paymentFilter' + '_pindex' + _pindex"
                  v-if="_pfilter.is_show_header"
                  class="table_header payment_bg"
                >
                  {{ _pfilter.header_name }}

                  <!-- <i
                    v-if="selectedPaymentFilter.length > 1"
                    @click="
                      removeFromDragged(
                        _pfilter.key_name,
                        'selectedPaymentFilter'
                      )
                    "
                    class="ml-1 fa fa-close pointer align-content-center justify-content-center"
                  >
                  </i> -->
                </td>
              </tr>

              <tbody v-if="finalOutputArray.length == 0">
                <tr>
                  <td colspan="13">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>

              <tbody v-if="finalOutputArray.length > 0">
                <tr
                  v-for="(filterNew3, index2) in finalOutputArray"
                  :key="'finalOutputArray' + 'index2' + index2"
                >
                  <td
                    v-for="(filter, index) in selectedGroupByArray"
                    :key="'selectedGroupByArray' + 'index' + index"
                    v-if="filterNew3[filter.groupByKeyName + '_status']"
                    :rowspan="filterNew3[filter.groupByKeyName + '_rowspan']"
                    class="text-left"
                  >
                    {{ filterNew3[filter.showLabelName] }}
                  </td>
                  <td
                    v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                    :key="'paymentFilter' + '_pindex' + _pindex"
                    v-if="_pfilter.is_show_header"
                    class="text-right"
                  >
                    {{
                      _pfilter["is_curr_format"]
                        ? currFormat(filterNew3[_pfilter.key_name])
                        : filterNew3[_pfilter.key_name]
                    }}
                  </td>
                </tr>
                <tr
                  v-for="(grandTotalObj, index3) in grandTotalObject"
                  :key="'grandTotalObj' + 'index3' + index3"
                  v-if="false"
                >
                  <th
                    :colspan="selectedGroupByArray.length"
                    class="text-right table_header"
                  >
                    Grand Total
                  </th>
                  <th
                    v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                    :key="'paymentFilter' + '_pindex' + _pindex"
                    v-if="_pfilter.is_show_header"
                    class="text-right table_header"
                  >
                    {{
                      _pfilter["is_curr_format"]
                        ? currFormat(grandTotalObj[_pfilter.key_name])
                        : grandTotalObj[_pfilter.key_name]
                    }}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--Excel Export Ends-->
        <div class="swc-report">
          <div>
            <!--            <button class="btn-blue mb-2" @click="generateReport()">-->
            <!--              Download PDF-->
            <!--            </button>-->
            <table
              border="1"
              class="swc-report-table filmwise-report-table"
              id="finalTable"
            >
              <thead>
                <th
                  v-for="(filter, index) in selectedGroupByArray"
                  :key="'selectedGroupByArray' + 'index' + index"
                  class="table_header"
                >
                  {{ filter.tableHeaderName }}

                  <i
                    v-if="selectedGroupByArray.length > 1"
                    @click="
                      removeFromDragged(
                        filter.groupByKeyName,
                        'selectedGroupByArray'
                      )
                    "
                    class="ml-1 fa fa-close pointer align-content-center justify-content-center"
                  >
                  </i>
                </th>
                <th
                  v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                  :key="'paymentFilter' + '_pindex' + _pindex"
                  v-if="_pfilter.is_show_header"
                  class="table_header payment_bg"
                >
                  {{ _pfilter.header_name }}

                  <i
                    v-if="selectedPaymentFilter.length > 1"
                    @click="
                      removeFromDragged(
                        _pfilter.key_name,
                        'selectedPaymentFilter'
                      )
                    "
                    class="ml-1 fa fa-close pointer align-content-center justify-content-center"
                  >
                  </i>
                </th>
              </thead>

              <tbody v-if="finalOutputArray.length == 0">
                <tr>
                  <td colspan="13">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>

              <tbody v-if="finalOutputArray.length > 0">
                <tr
                  v-for="(filterNew3, index2) in finalOutputArray"
                  :key="'finalOutputArray' + 'index2' + index2"
                >
                  <td
                    v-for="(filter, index) in selectedGroupByArray"
                    :key="'selectedGroupByArray' + 'index' + index"
                    v-if="filterNew3[filter.groupByKeyName + '_status']"
                    :rowspan="filterNew3[filter.groupByKeyName + '_rowspan']"
                    class="text-left"
                  >
                    {{ filterNew3[filter.showLabelName] }}
                  </td>
                  <td
                    v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                    :key="'paymentFilter' + '_pindex' + _pindex"
                    v-if="_pfilter.is_show_header"
                    class="text-right"
                  >
                    {{
                      _pfilter["is_curr_format"]
                        ? currFormat(filterNew3[_pfilter.key_name])
                        : filterNew3[_pfilter.key_name]
                    }}
                  </td>
                </tr>
                <tr
                  v-for="(grandTotalObj, index3) in grandTotalObject"
                  :key="'grandTotalObj' + 'index3' + index3"
                >
                  <th
                    :colspan="selectedGroupByArray.length"
                    class="text-right table_header"
                  >
                    Grand Total
                  </th>
                  <th
                    v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                    :key="'paymentFilter' + '_pindex' + _pindex"
                    v-if="_pfilter.is_show_header"
                    class="text-right table_header"
                  >
                    {{
                      _pfilter["is_curr_format"]
                        ? currFormat(grandTotalObj[_pfilter.key_name])
                        : grandTotalObj[_pfilter.key_name]
                    }}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="finalOutputArray.length > 0" style="display:none">
            <!--            <button class="btn-blue mb-2" @click="generateReport()">-->
            <!--              Download PDF-->
            <!--            </button>-->

            <vue-html2pdf
              :show-layout="false"
              :float-layout="false"
              :enable-download="false"
              :paginate-elements-by-height="1400"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a2"
              pdf-orientation="landscape"
              pdf-content-width="100%"
              @beforeDownload="beforeDownload($event)"
              ref="html2Pdf"
            >
              <div slot="pdf-content" class="p-3">
                <div class="d-flex justify-content-between">
                  <div class="pdf_left">
                    <p class="h5 my-1">
                      {{ selectedPreset ? selectedPreset.rp_name : "Reports" }}
                    </p>
                    <p class="my-1">
                      From
                      {{
                        moment(fetchReportsDetail.from_date).format(
                          "YYYY-MM-DD"
                        )
                      }}-
                      {{
                        moment(fetchReportsDetail.to_date).format("YYYY-MM-DD")
                      }}
                    </p>
                  </div>
                  <div class="pdf_right">
                    <div class="pdf_img">
                      <img
                        :src="getorgData[0].org_logo_url"
                        alt="Stuessihof"
                        crossorigin="*"
                      />
                    </div>
                    <p class="my-1">{{ getorgData[0].org_name }}</p>
                    <p class="my-1">{{ getorgData[0].org_address }}</p>
                  </div>
                </div>
                <table
                  border="1"
                  class="swc-report-table filmwise-report-table"
                >
                  <thead>
                    <th
                      v-for="(filter, index) in selectedGroupByArray"
                      :key="'selectedGroupByArray' + 'index' + index"
                      class="table_header"
                    >
                      {{ filter.tableHeaderName }}
                    </th>
                    <th
                      v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                      :key="'paymentFilter' + '_pindex' + _pindex"
                      v-if="_pfilter.is_show_header"
                      class="table_header"
                    >
                      {{ _pfilter.header_name }}
                    </th>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(filterNew3, index2) in finalOutputArray"
                      :key="'finalOutputArray' + 'index2' + index2"
                    >
                      <td
                        v-for="(filter, index) in selectedGroupByArray"
                        :key="'selectedGroupByArray' + 'index' + index"
                        v-if="filterNew3[filter.groupByKeyName + '_status']"
                        :rowspan="
                          filterNew3[filter.groupByKeyName + '_rowspan']
                        "
                        class="text-left"
                      >
                        {{ filterNew3[filter.showLabelName] }}
                      </td>
                      <td
                        v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                        :key="'paymentFilter' + '_pindex' + _pindex"
                        v-if="_pfilter.is_show_header"
                        class="text-right"
                      >
                        {{
                          _pfilter["is_curr_format"]
                            ? currFormat(filterNew3[_pfilter.key_name])
                            : filterNew3[_pfilter.key_name]
                        }}
                      </td>
                    </tr>
                    <tr
                      v-for="(grandTotalObj, index3) in grandTotalObject"
                      :key="'grandTotalObj' + 'index3' + index3"
                    >
                      <th
                        :colspan="selectedGroupByArray.length"
                        class="text-right table_header"
                      >
                        Grand Total
                      </th>
                      <th
                        v-for="(_pfilter, _pindex) in selectedPaymentFilter"
                        :key="'paymentFilter' + '_pindex' + _pindex"
                        v-if="_pfilter.is_show_header"
                        class="text-right table_header"
                      >
                        {{
                          _pfilter["is_curr_format"]
                            ? currFormat(grandTotalObj[_pfilter.key_name])
                            : grandTotalObj[_pfilter.key_name]
                        }}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vue-html2pdf>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MasterService from "@/services/MasterService";
  import moment from "moment-timezone";
  import DatePicker from "vue2-datepicker";
  import Multiselect from "vue-multiselect";
  import _ from "lodash";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import draggable from "vuedraggable";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: { VueHtml2pdf, DatePicker, Multiselect, NoRecords, draggable },
    data() {
      return {
        isOpen: true,
        isMultiselectFilter: true,
        showDropDownFilter: false,
        presetName: "",
        collapseObj: {
          groupByFilter: false,
          paymentFilter: false,
          others: false,
          filterToggle: false,
        },
        htmlToPdfOptions: {
          filename: this.pdfFileName,
          margin: 3,
          image: {
            type: "jpeg",
            quality: 0.98,
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            format: "a2",
            orientation: "landscape",
          },
        },
        CinemasCopy: [],
        searchCinema: "",
        btenable: false,
        groupByFilterArray: [],
        groupByFilterArrayCopy: [],

        fetchReportsDetail: {
          cinema_id: null,
          from_date: moment().toDate(),
          to_date: new Date(),
        },
        selectedCinema: "",
        Cinemas: [],

        groupByTransactions: [],
        Records: [],
        RecordsCopy: [],
        selectedGroupByArray: [],
        finalDataArray: [],
        finalOutputArray: [],
        paymentFilter: [],
        paymentFilterCopy: [],
        selectedPaymentFilter: [],
        pdfFileName: "",

        selectedPreset: null,
        savedPreset: [],
        grandTotalObject: [],
        getorgData: [],
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      // this.getCurrencyCode();
      this.isRoleID = false;
      this.getCinemaList(obj);

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onSelectCinema(null, CinemaObj);
      }

      //console.log("transactions page route", this.$route);
      let queryparams = this.$route.query;

      if (queryparams.cinema_id && parseInt(queryparams.cinema_id)) {
        this.fetchReportsDetail.cinema_id = parseInt(queryparams.cinema_id);
      }

      // this.onGetTransactionList();
      this.getviewingnumber();
      this.getOrgReport();
    },
    watch: {
      "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        if (CinemaObj) {
          this.onSelectCinema(null, CinemaObj);
        }
      },
    },
    computed: {
      checkValidation() {
        return !!(
          this.fetchReportsDetail.from_date && this.fetchReportsDetail.to_date
        );
      },
    },
    methods: {
      moment,
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, { sheet: "Report Builder" });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(wb, fn || "ReportBuilder." + (type || "xlsx"));
      },
      open() {
        let open_dropdown = document.getElementsByClassName(
          "multiselect__content-wrapper"
        );
        if (filter.filterAccordion == true) {
          // this.$refs.multiselect.activate()
          open_dropdown.style.display = "block";
        }
      },
      getOrgReport() {
        MasterService.GetOrgDetails().then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.getorgData = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        });
      },
      async beforeDownload({ html2pdf, options, pdfContent }) {
        const date = new Date();
        this.pdfFileName = "Reports" + date.getTime();
        this.htmlToPdfOptions.filename = this.pdfFileName;
        await html2pdf()
          .set(this.htmlToPdfOptions)
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(18);
              pdf.setTextColor(150);
              pdf.text(
                "Page " + i + " of " + totalPages,
                pdf.internal.pageSize.getWidth() * 0.88,
                pdf.internal.pageSize.getHeight() - 0.3
              );
            }
          })
          .save();
      },

      generateReport() {
        this.$refs.html2Pdf &&
          this.$refs.html2Pdf.generatePdf &&
          this.$refs.html2Pdf.generatePdf();
      },

      onGroupFilterChange: function(evt) {
        if (!evt) return;

        let loader = this.$loading.show();

        this.clearReportData();
        this.getRecordsSet();

        setTimeout(() => loader.hide(), 100);
      },

      onPaymentFilterChange: function(evt) {
        if (!evt) return;

        let loader = this.$loading.show();

        this.clearReportData();
        this.getRecordsSet();

        setTimeout(() => loader.hide(), 100);
      },
      checkMoveonGroupFilterChange: function(evt, originalEvent) {
        if (evt.from.localName != evt.to.localName) {
          // this.$toasted.show('Invalid Drag Option');
          return false; // for cancel drag
        }

        return true;
      },
      checkMoveonPaymentFilterChange: function(evt, originalEvent) {
        if (evt.from.localName != evt.to.localName) {
          // this.$toasted.show('Invalid Drag Option');
          return false; // for cancel drag
        }

        return true;
      },

      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },

      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          //console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          //console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },

      clearDate(type = 1) {
        this.currentPage = 1;
        switch (type) {
          case 2:
          case "to_date":
            this.fetchReportsDetail.from_date = "";
            this.fetchReportsDetail.to_date = "";
            break;
        }
      },

      onchangeDate: _.debounce(function(query) {
        this.searchReservations = "";
        this.clearReportData(true);
        this.currentPage = 1;
      }, 500),

      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },

      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.fetchReservationDetail.cinema_id = x.cine_id;
                  // this.selectedCinema = x.cine_name;
                  this.onSelectCinema(null, {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  });
                }

                if (
                  this.fetchReportsDetail &&
                  this.fetchReportsDetail.cinema_id &&
                  x.cine_id === this.fetchReportsDetail.cinema_id
                ) {
                  this.selectedCinema = x.cine_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },

      onSelectCinema: function(event, params) {
        this.searchCinema = "";
        this.searchReservations = "";
        this.onSearchCinema(null);
        this.$store.dispatch("selectDropdownCinema", params);
        this.selectedCinema = params.cine_name;
        this.fetchReportsDetail.cinema_id = params.cine_id;
        if (this.fetchReportsDetail.from_date) {
          this.onGetReportData();
        } else {
          this.$toasted.show("Please select date");
        }
      },

      toggleShowDropDownFilter: function() {
        this.showDropDownFilter = !this.showDropDownFilter;
        //this.$forceUpdate();

        this.$nextTick(() => {
          this.Records = this.RecordsCopy;

          this.selectedGroupByArray.forEach((s) => {
            s.selectedDropdownFilter = s.defaultDropdownFilter;
          });

          this.clearReportData();
          this.getRecordsSet();
        });
      },

      clearSelectedFilter: function(group, type, meta) {
        group.filterAccordion = !group.filterAccordion;
        group.selectedDropdownFilter = [];
        this.onSelectDropdownFilter(undefined, group, type, meta);
      },

      onSelectDropdownFilter: function(event, group, type, meta) {
        // if (!this.showDropDownFilter) return

        this.$nextTick(() => {
          //console.log({ event, group, type, meta });
          let selectedFilters = this.selectedGroupByArray
            .map((s) => {
              if (s.hasOwnProperty("selectedDropdownFilter")) {
                return Array.isArray(s.selectedDropdownFilter) &&
                  this.isMultiselectFilter
                  ? s.selectedDropdownFilter
                  : [s.selectedDropdownFilter];
              }
              return null;
            })
            // .flatMap(x => x)
            .filter((x) => !!x)
            .filter((x) => x.length);

          //console.log({
          //   selectedFilters
          // });

          if (
            selectedFilters.flatMap((x) => x).filter((x) => !!x).length === 0
          ) {
            //console.log("no filters", selectedFilters.flatMap(x => x))
            this.Records = this.RecordsCopy;
            this.clearReportData();
            this.getRecordsSet();
            return;
          }

          let toFilterTrx = this.RecordsCopy.map((x) => x);

          selectedFilters.forEach((f) => {
            if (f.length == 0) return true;

            let keyToBeUsed = "";

            let filterValues = f
              .map((x) => {
                let ks = Object.keys(x);

                let idKey = ks.filter((k) => k.includes("_id"));
                let nameKey = ks.filter((k) => k.includes("_name"));

                keyToBeUsed = idKey.length
                  ? idKey[0]
                  : nameKey.length
                  ? nameKey[0]
                  : ks[0];

                return x[`${keyToBeUsed}`];
              })
              .filter((x) => !!x);

            //console.log({
            //   keyToBeUsed,
            //   filterValues
            // });

            toFilterTrx = toFilterTrx.filter((t) => {
              if (filterValues.length == 0) return true;

              return filterValues.includes(t[`${keyToBeUsed}`]);
            });
          });

          this.Records = toFilterTrx;
          this.clearReportData();
          this.getRecordsSet();
        });
      },

      onSelectPreset: function(preset = null) {
        this.clearReportData();
        this.selectedPreset = preset;

        if (!preset) {
          this.setDefaultSelections({
            filterArray: this.groupByFilterArrayCopy,
            payment_right_filter: this.paymentFilterCopy,
          });
        }

        if (
          preset &&
          preset.preset_json &&
          preset.preset_json.selectedGroupByArray
        ) {
          let selectedGroupByArray = [];

          preset.preset_json.selectedGroupByArray.forEach((selected) => {
            let find = this.groupByFilterArrayCopy.filter(
              (x) => x.groupByKeyName == selected.groupByKeyName
            );
            if (find && find.length > 0) {
              selectedGroupByArray.push(find[0]);
            }
          });

          this.selectedGroupByArray = selectedGroupByArray;
          // this.groupByFilterArray = this.groupByFilterArrayCopy - selectedGroupByArray
          this.groupByFilterArray = _.differenceWith(
            this.groupByFilterArrayCopy,
            selectedGroupByArray,
            _.isEqual
          );
        }

        if (
          preset &&
          preset.preset_json &&
          preset.preset_json.selectedPaymentFilter
        ) {
          let selectedPaymentFilter = [];

          preset.preset_json.selectedPaymentFilter.forEach((selected) => {
            let find = this.paymentFilterCopy.filter(
              (x) => x.key_name == selected.key_name
            );
            if (find && find.length > 0) {
              selectedPaymentFilter.push(find[0]);
            }
          });

          this.selectedPaymentFilter = selectedPaymentFilter;
          // this.paymentFilter = this.paymentFilterCopy - selectedPaymentFilter
          this.paymentFilter = _.differenceWith(
            this.paymentFilterCopy,
            selectedPaymentFilter,
            _.isEqual
          );
        }

        //this.$forceUpdate();
        this.getRecordsSet();
      },

      onSavePreset: function(event, preset) {
        if (!this.presetName) {
          this.$toasted.show("Please enter template name to save");
          return;
        }

        let selectedGroupByArray = this.selectedGroupByArray.map((g, index) => {
          return {
            groupByKeyName: g.groupByKeyName,
            is_order: index,
          };
        });
        let selectedPaymentFilter = this.selectedPaymentFilter.map(
          (g, index) => {
            return {
              key_name: g.key_name,
              is_order: index,
            };
          }
        );

        let payload = {
          rp_name: String(this.presetName || "").trim() || "Report Preset",
          save_id: 1,
          preset_json: {
            selectedGroupByArray,
            selectedPaymentFilter,
          },
        };

        MasterService.saveReportPresetWithChecker(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show("Report Preset Saved");
              payload.rp_id = data.report_preset_id[0];
              this.savedPreset.push(payload);
              this.selectedPreset = payload;
              //this.$forceUpdate();
            } else {
              this.$toasted.show("Error while saving report preset");
            }
          })
          .finally(() => {
            this.presetName = "";
            this.clearReportData();
            this.getRecordsSet();
          });
      },

      onDeletePreset: function() {
        if (!this.selectedPreset || !this.selectedPreset.rp_id) return;

        let payload = {
          rp_is_active: "N",
        };

        MasterService.updateReportPreset(this.selectedPreset.rp_id, payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.savedPreset = this.savedPreset.filter(
                (p) => p.rp_id != this.selectedPreset.rp_id
              );
              this.$toasted.show("Report Preset Deleted");

              this.clearReportData();
            } else {
              this.$toasted.show("Error while deleting report preset");
            }
          })
          .finally(() => {
            this.getRecordsSet();
          });
      },

      clearReportData: function(skipLoader = false) {
        let loader = { hide: () => {} };
        if (!skipLoader) loader = this.$loading.show();

        this.presetName = "";
        this.finalDataArray = [];
        this.groupByTransactions = [];
        this.finalOutputArray = [];

        setTimeout(() => loader.hide(), 660);
        //this.$forceUpdate();
      },

      setDefaultSelections: function(data) {
        let { filterArray = [], payment_right_filter = [] } = data;

        this.paymentFilterCopy = payment_right_filter;
        this.paymentFilter = payment_right_filter.filter(
          (x) => x.is_preselected_filter != true
        );
        if (this.selectedPaymentFilter.length == 0) {
          this.selectedPaymentFilter = payment_right_filter
            .filter((x) => x.is_preselected_filter == true)
            .sort((a, b) => a.is_order - b.is_order);
        }

        this.groupByFilterArrayCopy = filterArray;
        this.groupByFilterArray = filterArray.filter(
          (x) => x.is_preselected_filter != true
        );
        if (this.selectedGroupByArray.length == 0) {
          this.selectedGroupByArray = filterArray
            .filter((x) => x.is_preselected_filter == true)
            .sort((a, b) => a.is_order - b.is_order);
        }

        //this.$forceUpdate();
      },

      onGetReportData: function() {
        this.clearReportData();
        if (this.selectedGroupByArray.length) {
          this.selectedGroupByArray.map((z) => {
            // z.filterAccordion = false;
            z.selectedDropdownFilter = [];
          });
        }

        // if(!this.fetchReservationDetail.cinema_id) this.$toasted.show("Please select cinema")

        if (
          (!this.fetchReportsDetail.to_date &&
            !this.fetchReportsDetail.from_date) ||
          (this.fetchReportsDetail.to_date &&
            !this.fetchReportsDetail.from_date) ||
          (!this.fetchReportsDetail.to_date &&
            this.fetchReportsDetail.from_date)
        ) {
          this.$toasted.show("Please select date range properly");
          return;
        }

        if (this.checkValidation) {
          let loader = this.$loading.show();

          this.btenable = true;
          let payload = {
            skipDefaultData: true,
            cinema_id: this.fetchReportsDetail.cinema_id,

            filter_with_key: "t_booking_date_time",
            fromDate: this.fetchReportsDetail.from_date
              ? moment(this.fetchReportsDetail.from_date).format("YYYY-MM-DD")
              : null,
            toDate: this.fetchReportsDetail.to_date
              ? moment(this.fetchReportsDetail.to_date).format("YYYY-MM-DD")
              : null,
          };

          MasterService.getReportBuilderDetail(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status && data.Records && data.Records.length > 0) {
                this.Records = data.Records;
                this.RecordsCopy = data.Records;

                if (data.filterArray && data.filterArray.length > 0) {
                  data.filterArray.forEach((f) => {
                    // f.defaultDropdownFilter =
                    //   f.data && f.data.length
                    //     ? this.isMultiselectFilter
                    //       ? [f.data[0]]
                    //       : f.data[0]
                    //     : this.isMultiselectFilter
                    //     ? []
                    //     : {};
                    // f.selectedDropdownFilter =
                    //   f.data && f.data.length
                    //     ? this.isMultiselectFilter
                    //       ? [f.data[0]]
                    //       : f.data[0]
                    //     : this.isMultiselectFilter
                    //     ? []
                    //     : {};

                    f.defaultDropdownFilter = [];
                    f.selectedDropdownFilter = [];
                  });
                }

                this.savedPreset = data.savedPreset
                  .filter((x) => !!x)
                  .filter((x) => (x.rp_is_active = "Y"));
                this.setDefaultSelections(data);

                this.$nextTick(() => {
                  this.getRecordsSet();
                });
              } else if (data.Records && data.Records.length == 0) {
                // this.clearReportData()
                this.Records = [];
                this.RecordsCopy = [];
                //this.$forceUpdate()
                this.$nextTick(() => {
                  this.getRecordsSet();
                });
                this.$toasted.show("No Records Found.");
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((e) => {
              //console.log({ e });
              this._CatchError(e);
            })
            .finally(() => {
              setTimeout(() => loader.hide(), 100);
            });
        } else {
          this.$toasted.show("Invalid Selection");
        }
      },

      getRecordChildren(x, data2) {
        let data = _.groupBy(data2.dummy_data, x.groupByKeyName);
        data2[x.groupByArrayName] = [];
        Object.keys(data).map((z) => {
          let obj = {};
          obj[x.groupByKeyName] = z;
          obj["dummy_data"] = [];
          data[z].map((k) => {
            obj["dummy_data"].push(k);
          });
          data2[x.groupByArrayName].push(obj);
          // this.finalllTTransaction.push(obj)
        });

        let findIndexxxNeww = this.selectedGroupByArray.findIndex((jjj) => {
          return jjj.groupByKeyName == x.groupByKeyName;
        });
        //console.log(findIndexxxNeww, "fsfsd", data2[x.groupByArrayName]);
        if (findIndexxxNeww < this.selectedGroupByArray.length - 1) {
          data2[x.groupByArrayName].map((newwwArr) => {
            this.getRecordChildren(
              this.selectedGroupByArray[findIndexxxNeww + 1],
              newwwArr
            );
          });
        }
      },

      getRecordsSet() {
        console.time("getRecordsSet");
        let loader = this.$loading.show();
        setTimeout(() => loader.hide(), 200);

        this.selectedGroupByArray = this.selectedGroupByArray.filter(
          (x) => !!x
        );

        this.selectedGroupByArray.map((x, index) => {
          if (index == 0) {
            let data = _.groupBy(this.Records, x.groupByKeyName);

            Object.keys(data).map((z) => {
              let obj = {};
              obj[x.groupByKeyName] = z;
              obj["dummy_data"] = [];
              data[z].map((k) => {
                obj["dummy_data"].push(k);
              });
              this.groupByTransactions.push(obj);
            });
          } else if (index == 1) {
            this.groupByTransactions.map((final_val) => {
              this.getRecordChildren(x, final_val);
            });
          }
        });

        //console.log(this.groupByTransactions, "dsfdsfs333333d");
        // setTimeout(() => {
        this.getData();
        // }, 1000)

        console.timeEnd("getRecordsSet");
      },

      setFinalOutputArray() {
        let finalOutput = [];
        let filterArray = {};
        if (this.selectedGroupByArray.length == 1) {
          let groupLastArray = this.selectedGroupByArray[
            this.selectedGroupByArray.length - 1
          ]["groupByKeyName"];

          this.finalDataArray[0].map((x) => {
            x[groupLastArray + "_rowspan"] = 1;
            x[groupLastArray + "_status"] = true;
          });
          finalOutput = this.finalDataArray[0];
        } else {
          this.finalDataArray.map((x) => {
            x.map((dataaa) => {
              let arrayNew = [];
              this.selectedGroupByArray.map((z, index) => {
                dataaa[z.groupByKeyName + "_rowspan"] = 1;
                dataaa[z.groupByKeyName + "_status"] = true;
                if (index != this.selectedGroupByArray.length - 1) {
                  let findIndexForNew = finalOutput.findIndex((k) => {
                    if (arrayNew.length > 0) {
                      let count = 0;
                      arrayNew.map((_fil) => {
                        if (k[_fil] == dataaa[_fil]) {
                          count++;
                        }
                      });
                      //console.log(arrayNew);
                      return (
                        k[z.groupByKeyName] == dataaa[z.groupByKeyName] &&
                        count == arrayNew.length
                      );
                    } else {
                      return k[z.groupByKeyName] == dataaa[z.groupByKeyName];
                    }
                  });
                  if (findIndexForNew >= 0) {
                    finalOutput[findIndexForNew][
                      z.groupByKeyName + "_rowspan"
                    ] =
                      finalOutput[findIndexForNew][
                        z.groupByKeyName + "_rowspan"
                      ] + 1;
                    dataaa[z.groupByKeyName + "_status"] = false;
                  }
                  arrayNew.push(z.groupByKeyName);
                }
              });
              finalOutput.push(dataaa);
            });
          });
        }

        //console.log("finalOutput", finalOutput);
        this.finalOutputArray = finalOutput;
        this.getPaymentCalculation();

        this.$forceUpdate();
      },

      getPaymentCalculation() {
        let grandTotalObject2 = {};
        this.grandTotalObject = [];
        this.selectedPaymentFilter.map((zzz) => {
          grandTotalObject2[zzz.key_name] = 0;
        });
        this.finalOutputArray.map((x) => {
          this.selectedPaymentFilter.map((z) => {
            z["is_show_header"] = true;
            x[z.key_name] = 0;
            let schedule_array = [];
            x.dummy_data.map((_dd) => {
              if (z.key_name == "no_of_show") {
                z["is_show_header"] = false;
                if (this.selectedGroupByArray.length == 1) {
                  let applicable_on = [
                    "movie_id",
                    "cinema_id",
                    "screen_id",
                    "md_id",
                    "t_show_date",
                    "t_booking_date_time",
                  ].indexOf(
                    this.selectedGroupByArray[
                      this.selectedGroupByArray.length - 1
                    ]["groupByKeyName"]
                  );
                  if (applicable_on >= 0) {
                    z["is_show_header"] = true;
                  }
                }
                let schedule_array_index = schedule_array.indexOf(
                  _dd.schedule_show_id
                );
                if (schedule_array_index < 0) {
                  schedule_array.push(_dd.schedule_show_id);
                  x[z.key_name] = x[z.key_name] + 1;
                }
              } else if (z.key_name == "no_of_tickets") {
                x[z.key_name] = x.dummy_data.length;
              } else if (z.key_name == "other_misc_sales") {
                x[z.key_name] = +parseFloat(
                  x[z.key_name] + _dd["internet_handling_fee"]
                );
              } else if (z.key_name == "total_sales") {
                x[z.key_name] = +parseFloat(
                  x[z.key_name] +
                    _dd["internet_handling_fee"] +
                    _dd["t_gross_amount_before_offer"] -
                    _dd["t_offer_price"]
                );
              } else if (z.is_column_available) {
                x[z.key_name] = +parseFloat(x[z.key_name] + _dd[z.key_name]);
              } else if (z.key_name == "payment_mode_" + _dd.payment_mode_id) {
                x[z.key_name] = +parseFloat(
                  x[z.key_name] +
                    (_dd["t_gross_amount"] - _dd["cash_card_amount"])
                );
              }
            });
            grandTotalObject2[z.key_name] = +parseFloat(
              grandTotalObject2[z.key_name] + x[z.key_name]
            );
          });
        });
        this.grandTotalObject.push(grandTotalObject2);
        // this.generateReport();
        //console.log(this.grandTotalObject, "this.grandTotalObject");
      },

      getChildren(x) {
        let groupLastArray = this.selectedGroupByArray[
          this.selectedGroupByArray.length - 1
        ]["groupByArrayName"];
        let groupFirstArray = this.selectedGroupByArray[0]["groupByArrayName"];
        let keyNameCheck = Object.keys(x).findIndex((z) => {
          return z == groupLastArray;
        });

        if (keyNameCheck >= 0) {
          let arrayNew = [];
          //console.log(groupLastArray, "fsddfsdfd");
          x[groupLastArray].map((z) => {
            // z.dummy_data.map(kkk => {
            arrayNew.push({ ...z, ...z.dummy_data[0] });
            // })
          });

          this.finalDataArray.push(arrayNew);
        } else {
          let insideKeyCheck = this.selectedGroupByArray.filter((z) => {
            return Object.keys(x).indexOf(z.groupByArrayName) >= 0;
          });

          if (insideKeyCheck.length > 0) {
            x[insideKeyCheck[0].groupByArrayName].map((k) => {
              this.getChildren(k);
            });
          } else if (this.selectedGroupByArray.length == 1) {
            let arrayNew = [];
            this.groupByTransactions.map((z) => {
              arrayNew.push({ ...z, ...z.dummy_data[0] });
            });
            this.finalDataArray.push(arrayNew);
            //console.log(this.finalDataArray, "fsddfsdfsdfsdfsd");
          }
        }
      },

      getData() {
        //console.log(
        //   this.groupByTransactions,
        //   this.selectedGroupByArray,
        //   "this.finalDataArray"
        // );
        this.groupByTransactions.map((x) => {
          this.getChildren(x);
        });
        this.setFinalOutputArray();
      },

      highestValue(array, index) {
        // let count=0;
        // array.map((x,indexNew)=>{
        //   if(index>)
        // })
        // return count;
      },

      updateOnlineStatus(e) {
        const { type } = e;
        this.onLine = type === "online";
      },
      removeFromDragged: function(key, from) {
        if (!key || !from) return;

        let toFilter = [];

        if (from == "selectedGroupByArray") {
          [toFilter] = this.selectedGroupByArray.filter(
            (x) => x.groupByKeyName === key
          );

          if (!!toFilter) {
            this.selectedGroupByArray = this.selectedGroupByArray.filter(
              (x) => x.groupByKeyName !== key
            );
            this.groupByFilterArray.push(toFilter);
          }
        }

        if (from == "selectedPaymentFilter") {
          [toFilter] = this.selectedPaymentFilter.filter(
            (x) => x.key_name === key
          );

          if (!!toFilter) {
            this.selectedPaymentFilter = this.selectedPaymentFilter.filter(
              (x) => x.key_name !== key
            );
            this.paymentFilter.push(toFilter);
          }
        }

        //console.log({ key, from, toFilter })

        this.clearReportData();
        this.getRecordsSet();
      },

      /*filterOnChange: function(event, option, filter){
      if (filter.selectedDropdownFilter.length === 1 && !event.target.checked) return

      this.$nextTick(() => {
        const {checked} = event.target;
        //console.log({event, option, filter, checked})

        //console.log(
        //   filter.selectedDropdownFilterValues.includes(option[filter.groupByKeyName]),
        //   'filter.selectedDropdownFilterValues', filter.selectedDropdownFilterValues,
        //   'filter.groupByKeyName', filter.groupByKeyName,
        //   'option[filter.showLabelName]', option[filter.groupByKeyName]
        // )

        if (option && filter && checked) {
          filter.selectedDropdownFilterValues.push(option[filter.groupByKeyName])
          filter.selectedDropdownFilter.push(option)
          this.onSelectDropdownFilter(event, filter, checked ? 'add' : 'remove', {checked})
        }
        else if (option && filter && !checked) {
          if (filter.selectedDropdownFilter.length === 1) return

          filter.selectedDropdownFilter = filter.selectedDropdownFilter.filter(x => x[filter.groupByKeyName] != option[filter.groupByKeyName])
          filter.selectedDropdownFilterValues = filter.selectedDropdownFilterValues.filter(x => x != option[filter.groupByKeyName])
          this.onSelectDropdownFilter(event, filter, checked ? 'add' : 'remove', {checked})
        }
      })
    },*/
    },
  };
</script>

<style scoped>
  .sph-report th,
  td {
    height: 30px;
  }

  .filmwise-report-table > div {
    display: contents;
  }

  .table_header {
    background-color: #c4c5c6;
    color: #3a4759;
    font-weight: 900;
    border-color: #787878;
  }

  .filmwise-report-table td,
  .filmwise-report-table th {
    color: #3a4759;
    border-color: #787878;
  }

  .global_option_wrapper label:not(.custom-control-label) {
    font-size: 11px !important;
  }

  .compulsory_astrick {
    top: -5px;
    right: -4px;
    font-size: 19px;
    position: absolute;
    color: red;
  }

  .checkboxWrapper {
    width: 250px;
    font-size: 13px;
  }

  .global_option_wrapper .multiselect__single {
    font-size: 13px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .global_option_wrapper .multiselect__content-wrapper {
    width: auto;
  }

  .sectionName {
    padding: 5px 0px;
    color: var(--blue);
  }

  .sectionName .fs-17 {
    /*font-size: 17px !important;*/
  }

  .text-small-instruction {
    font-weight: 400;
  }

  .text-red {
    color: red;
  }

  .disable-field {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .move {
    cursor: move;
  }

  .pointer {
    cursor: pointer;
  }
  .pdf_img {
    width: 150px;
  }
  .pdf_img img {
    width: 100%;
  }
  .payment_bg {
    background-color: var(--blue);
  }

  .filterButtonToggle {
    min-width: fit-content !important;
    max-width: fit-content !important;
    width: fit-content !important;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .filterSection {
    min-width: 256px;
    border: 1px solid;
    border-radius: 7px;
    border-top-left-radius: 0;
    border-color: var(--lightgrey);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/reportBuilderComponents/reportBuilderComponents.vue